import { HttpStatusCode } from 'axios';
import {API} from '../config/config';
import axios from 'axios';
import buildResponse from './helpers';

const MovementService = {
  save: (storeId, data) => saveMovement(storeId, data),
  getAll: (storeId) => getAll(storeId),
  searchMovements: (storeId, query) => searchMovements(storeId, query),
  searchPaymentMovements: (query) => searchPaymentMovements(query)
};

const getAll = async (storeId) => {
    try {
      var response = await API.get(`/stores/${storeId}/movements`)
      return response.data;
    } catch (err) {
      console.error('Error:', err);
      throw new Error(err)
    }
  }

const saveMovement = async (storeId, data) => {
  try {
    var response = await API.post(`/stores/${storeId}/movements`, data)
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

const searchMovements = async (storeId, query) => {
    try {
      // query puede ser string (legacy) o un objeto { date, dateTo, type: string | string[] }
      let queryString;
      if (typeof query === 'string') {
        queryString = query;
      } else {
        const params = new URLSearchParams();
        if (query.date !== undefined) params.append('date', query.date);
        if (query.dateTo !== undefined) params.append('dateTo', query.dateTo);
        const types = Array.isArray(query.type) ? query.type : (query.type ? [query.type] : []);
        types.forEach(t => params.append('type', t));
        queryString = params.toString();
      }
      var response = await API.get(`/stores/${storeId}/movements?` + queryString)
      return response.data;
    } catch (err) {
      console.error('Error:', err);
      throw new Error(err)
    }
  }

const searchPaymentMovements = async (query) => {
  try {
    var response = await API.get(`/stores/movements/paymentmovements?` + query)
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

export default MovementService;
